import isEqual from 'lodash-es/isEqual'
import * as raf from 'raf'
import * as React from 'react'
import { RouteConfig } from 'react-router-config'
import { Route } from 'react-router-dom'
import { Store } from 'redux'

import { reportPageView, reportRouteChange } from '../../common/analytics'
import { IRootState } from '../../common/reducers'
import ga from '../../common/utils/ga'
import { ICommonLocation } from '../../common/utils/location/types'
import {
  callBeforePageViewHandlers,
  fetchAllRequests
} from '../../common/utils/router'
import { Props as IPendingNavDataLoaderProps } from '../containers/pendingNavDataLoaderContainer'

class PendingNavDataLoader extends React.Component<IPendingNavDataLoaderProps> {
  public componentDidMount() {
    const { store, routes, location } = this.props
    this.reportPageView(store, location, routes)
  }

  public componentWillReceiveProps(nextProps: IPendingNavDataLoaderProps) {
    const {
      store,
      routes,
      alerts,
      errorPage,
      resetAlerts,
      resetErrorPage,
      setCanonicalPath,
      setUserSearchResultsViewType
    } = this.props
    const currentLocation = this.props.location
    const nextLocation = nextProps.location

    // check whether url has changed
    const navigated = !isEqual(currentLocation, nextLocation)

    if (navigated) {
      // https://developers.intercom.com/installing-intercom/docs/intercom-javascript#section-intercomupdate
      if ('Intercom' in window) {
        Intercom('update')
      }

      // Reset / hide alerts when changing the route after first rendering
      if (alerts.length) {
        resetAlerts()
      }

      // Reset (remove) error page if present
      if (errorPage) {
        resetErrorPage()
      }

      // Reset canonical path to default value
      setCanonicalPath(nextLocation.pathname)

      if (
        typeof window !== 'undefined' &&
        nextLocation.query.view && // query is of a type of `[propName: string]: string | string[]`
        // so it can be potentially an array
        !Array.isArray(nextLocation.query.view)
      ) {
        setUserSearchResultsViewType(nextLocation.query.view)
      }

      // Update page location for GA
      ga('set', 'location', window.location.href)

      // Fetch request for route
      const promiseRequests = fetchAllRequests(store, nextLocation, routes, '')

      const report = () => {
        this.reportPageView(store, nextLocation, routes)
        reportRouteChange()
      }
      Promise.all(promiseRequests).then(report, report)
    }
  }

  public render() {
    const { children, location } = this.props

    return <Route location={location} render={() => children} />
  }

  private reportPageView(
    store: Store<IRootState>,
    nextLocation: ICommonLocation,
    routes: RouteConfig[]
  ) {
    callBeforePageViewHandlers(store, nextLocation, routes)
    // @see https://github.com/envato/market-shopfront/pull/2258
    raf(reportPageView)
  }
}

export default PendingNavDataLoader
